// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 3 ? "build-glob" : chunkId) + "-legacy." + {"3":"1aa0d257","82":"577f56e8","91":"b1d717ed","651":"b1fbd7d2","739":"25097739","846":"6276ae6a"}[chunkId] + ".js";
};